import React, { useEffect, useState } from "react";
import api, { formatRupiah, ROLE_LABEL } from "@/lib/api";
import Layout, { PageTitle, StatCard } from "@/components/Layout";
import { NAV_BENDAHARA } from "@/lib/nav";
import { useAuth } from "@/context/AuthContext";
import { Wallet, CheckCircle2, AlertCircle, Banknote } from "lucide-react";

export function BendaharaDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ sudah_bayar_spp: 0, belum_bayar_spp: 0, total_tunai: 0, total_transfer: 0 });
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/spp/stats/bendahara"); setStats(data); }
      catch (e) { console.error(e); }
    })();
  }, []);
  return (
    <Layout nav={NAV_BENDAHARA}>
      <PageTitle title={`Selamat datang, ${user?.nama || ROLE_LABEL[user?.role] || "Bendahara"}`} />
      <p className="text-sm text-slate-500 mb-6">Ringkasan pembayaran SPP untuk bulan berjalan.</p>
      <section className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Siswa Aktif Sudah Bayar SPP" value={stats.sudah_bayar_spp} icon={CheckCircle2} color="emerald" testId="stat-sudah" />
        <StatCard label="Siswa Aktif Belum Bayar SPP" value={stats.belum_bayar_spp} icon={AlertCircle} color="rose" testId="stat-belum" />
        <StatCard label="Total Dana Tunai" value={formatRupiah(stats.total_tunai)} icon={Wallet} color="indigo" testId="stat-tunai" />
        <StatCard label="Total Dana Transfer" value={formatRupiah(stats.total_transfer)} icon={Banknote} color="sky" testId="stat-transfer" />
      </section>
    </Layout>
  );
}
